import {repeat} from 'lit-html/directives/repeat';
import {until} from 'lit-html/directives/until';
export default (ctx, html) => html`
<div class="d-flex justify-content-center flex-wrap">
  ${repeat(ctx.legend, (i) => i.label, (i) => html`
    <div class="d-inline-flex align-items-center">
      <div class="key-icon mr-2 d-inline-flex" style="background-color: ${i.color};-webkit-print-color-adjust: exact;"></div>
      <div class="key-label mr-3 d-inline-flex">${until(i.label)}</div>
    </div>
  `)}
</div>
`;
